<template lang="pug">
span
  v-menu(v-model="showMenu" offset-y rounded="lg" :close-on-content-click="false" nudge-bottom="8" max-width="380")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="hasSelection" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size="13") $yzi-x-circle
        .text-xs.font-semibold Date
        .px-1.neutral400--text |
        .text-xs.primary--text.font-medium {{ displayText }}
        v-icon.ml-1(size="16") $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size="13") $yzi-plus-circle
        .text-xs.text-none.font-semibold Date

    .white
      .px-4.pt-4
        .font-semibold.text-sm.mb-3 Filter by date
        yz-tabs(v-model="mode" size="sm")
          yz-tab(label="Single")
          yz-tab(label="Range")

      .px-4
        yc-date-picker.filter-date-picker(:parentDate.sync="selectedDates" :range="isRangeMode")

      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="selectedDates" @click="clearSelection") Clear
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="!canApply") Apply
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'FilterDatePicker',
  props: {
    filter: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  data: () => ({
    showMenu: false,
    mode: 0, // 0 = single, 1 = range
    selectedDates: null,
    appliedDates: null,
    appliedMode: null
  }),
  computed: {
    isRangeMode() {
      return this.mode === 1
    },
    hasSelection() {
      return this.appliedDates !== null
    },
    canApply() {
      if (!this.selectedDates) return false
      if (this.isRangeMode) {
        return Array.isArray(this.selectedDates) && this.selectedDates.length === 2
      }
      return true
    },
    displayText() {
      if (!this.appliedDates) return ''
      const dateFormat = 'd MMM yyyy'
      if (this.appliedMode === 1 && Array.isArray(this.appliedDates)) {
        const sorted = [...this.appliedDates].sort()
        const start = DateTime.fromFormat(sorted[0], 'yyyy-MM-dd').toFormat(dateFormat)
        const end = DateTime.fromFormat(sorted[1], 'yyyy-MM-dd').toFormat(dateFormat)
        return `${start} - ${end}`
      }
      const date = Array.isArray(this.appliedDates) ? this.appliedDates[0] : this.appliedDates
      return DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat(dateFormat)
    }
  },
  watch: {
    filter: {
      handler(val) {
        if (!val || (Array.isArray(val) && val.length === 0) || (!Array.isArray(val) && !val.key)) {
          this.clearData()
        }
      },
      deep: true
    },
    mode() {
      // Reset selection when mode changes
      this.selectedDates = null
    }
  },
  methods: {
    apply() {
      this.showMenu = false
      this.appliedDates = this.selectedDates
      this.appliedMode = this.mode

      let filterValue
      if (this.isRangeMode && Array.isArray(this.selectedDates)) {
        const sorted = [...this.selectedDates].sort()
        filterValue = {
          key: 'between',
          value: [
            { key: 'date__gte', value: sorted[0] },
            { key: 'date__lte', value: sorted[1] }
          ]
        }
      } else {
        const date = Array.isArray(this.selectedDates) ? this.selectedDates[0] : this.selectedDates
        filterValue = {
          key: 'date',
          value: date
        }
      }
      this.$emit('update:filter', filterValue)
    },
    clear() {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearSelection() {
      this.selectedDates = null
    },
    clearData() {
      this.selectedDates = null
      this.appliedDates = null
      this.appliedMode = null
      this.mode = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}

.border-dashed {
  border-style: dashed !important;
}

::v-deep .filter-date-picker {
  .v-date-picker-table .v-btn.v-date-picker-table__current {
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active {
    background-color: #EEEEEE !important;
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active.v-date-picker--first-in-range,
  .v-btn.v-btn--active.v-date-picker--last-in-range {
    background-color: #333333 !important;
    .v-btn__content {
      color: #ffffff;
    }
  }
}
</style>
